/*
 * Preloader state
 * ===============
 *
 * Takes care of loading the main game assets, including graphics and sound
 * effects, while displaying a busy splash screen.
 */

import assets from '../assets';

export default class Preloader extends Phaser.State {

  preload() {
    this.showSplashScreen();
    this.load.pack('game', null, assets);

    // FILTERS
    this.game.load.script('filter-vignette', './filters/Vignette.js');
    this.game.load.script('filter-film',     './filters/FilmGrain.js');
    //this.game.load.script('filter-pixelate', './assets/js/filters/Pixelate.js');
    // this.game.load.script('pixi-filter-abstract', './assets/js/filters/AbstractFilter.js');
    // this.game.load.script('pixi-filter-sepia',    './assets/js/filters/SepiaFilter.js');
  }

  create() {
    // Here is a good place to initialize plugins dependent of any game asset.
    // Don't forget to `import` them first. Example:
    //this.game.myPlugin = this.plugins.add(MyPlugin/*, ... parameters ... */);

    this.state.start('Menu');
  }

  // --------------------------------------------------------------------------

  showSplashScreen() {
    this.add.image(0, 0, 'splash-screen');
    this.load.setPreloadSprite(this.add.image(82, 282, 'progress-bar'));
  }





}
